'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('blog-featured', {
  onLoad: function onLoad() {
    var container = this.container;
    var mostread = (0, _jquery2.default)(container).find('[data-blog-featured]');

    var settings = (0, _slick2.default)({
      appendDots: (0, _jquery2.default)(mostread).closest('.slick-slider-wrapper'),
      dots: false,
      arrows: true,
      prevArrow: (0, _jquery2.default)(container).find('[data-slick-prev]'),
      nextArrow: (0, _jquery2.default)(container).find('[data-slick-next]'),
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: Breakpoints['medium'],
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true
        }
      }, {
        breakpoint: Breakpoints['small'],
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }]
    });

    mostread.slick(settings);

    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);
  },
  onUnload: function onUnload() {}
});